import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const Activities = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('activities.bannerTitle')}
                path="/activities"
            />

            <div className="about-us-page">
                {/* Global'de Biz */}
                <div className="about-global-section">
                    <div className="container">
                        <h2 className="about-section-title">{t('activities.title')}</h2>
                        <div className="about-intro-section mb-5">
                            <p className="about-intro-text">{t('activities.intro.p1')}</p>
                            <p className="about-intro-text">{t('activities.intro.p2')}</p>
                            <p className="about-intro-text">{t('activities.intro.p3')}</p>
                        </div>

                        {/* Timeline */}
                        <div className="activities-timeline">
                            {t('activities.timeline', { returnObjects: true }).map((item, index) => (
                                <div key={index} className="timeline-item">
                                    <div className="timeline-marker">
                                        <span className="timeline-year">{item.year}</span>
                                    </div>
                                    <div className="timeline-content">
                                        <h3 className="timeline-title">
                                            {item.location}
                                        </h3>
                                        <p className="timeline-desc">{item.desc}</p>
                                        {item.details && (
                                            <ul className="timeline-details">
                                                {item.details.map((detail, idx) => (
                                                    <li key={idx}>{detail}</li>
                                                ))}
                                            </ul>
                                        )}
                                        {item.footer && (
                                            <p className="timeline-footer">{item.footer}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default Activities;
